import React from 'react';
import { Spin } from 'antd';
import styled from 'styled-components';

const StyledCenteredFullHeight = styled.div`
    height: 100%;
    justify-content: center;
    align-items: center;
    display: flex;
`;

export default ({ loading, children, displayChildren = false }) => {
    if (displayChildren) {
        return <Spin spinning={loading}>{children}</Spin>;
    } else {
        return loading ? (
            <StyledCenteredFullHeight>
                <Spin spinning={loading} />
            </StyledCenteredFullHeight>
        ) : (
            children
        );
    }
};
